import { useWorkspacePermissionContext } from 'wrappers/WorkspacePermissionProvider/WorkspacePermissionProvider';

import type { Permission } from '@fragment/authorization-utils';

export const useHasWorkspacePermission = (permission: Permission): boolean => {
  const { hasPermission } = useWorkspacePermissionContext();
  return hasPermission(permission);
};
